export const useContent = async (path) => {
  // Content v3 paths start with "/"; a bare path silently finds nothing.
  path = path.startsWith("/") ? path : `/${path}`;
  const { data } = await useAsyncData(path, () => {
    return queryCollection("content").path(path).first();
  });
  if (!data.value) {
    throw createError({
      statusCode: 404,
      statusMessage: "Page not found",
    });
  }
  return data;
};
